import React from 'react';

import { changeDateFormat, getActionDoneBy, getSampleActivityStatus, replaceUnderLine } from '@utils/Util';

const RequestTimeline = ({ requireDate, currentActivity, activityList }) => {
	const getStatus = (status, type) => {
		if ((status === 'PENDING' && currentActivity === type) || status === 'COMPLETED') {
			return getSampleActivityStatus(type, 'TIMELINE_STATUS');
		}
		return 'gray_dark_03';
	};

	return (
		<div className="design-timeline-container">
			<div className="design-timeline-header mb-4">
				<p className="semibold-16 mb-0">Sample Timeline</p>
				<p className="regular-14 gray_dark_02">
					Required: {changeDateFormat(requireDate, '', 'Do MMM, YYYY')}
				</p>
			</div>
			<ul className="design-timeline design-timeline-centered">
				{activityList?.map((item) => (
					<li
						className={`design-timeline-item status ${getStatus(
							item?.status,
							item?.activityType
						)}`}
						key={item.activityType}
					>
						<div className="design-timeline-marker" />
						<div className="design-timeline-content">
							<p className="regular-14">
								{replaceUnderLine(item.activityType) +
									getActionDoneBy(item?.userType || null)}
							</p>
							{item?.status === 'COMPLETED' && (
								<span className="regular-12">
									{changeDateFormat(
										item?.deliveryDate || item?.createdAt,
										'',
										'Do MMM, YYYY'
									)}
								</span>
							)}
						</div>
					</li>
				))}
			</ul>
		</div>
	);
};

export default RequestTimeline;
